<template>
    <div id="myAddress">
        <div class="windowsWrap">
            <el-radio-group v-model="radio" class="windowsWrap">
                <div class="windows" v-for="(item,index) in AddressList" :key="index">
                    <div class="windowsTop">
                        <span class="name">{{item.atName}}</span>
                        <i
                            class="el-icon-edit-outline"
                            @click="edit(item)"
                        ></i>
                    </div>
                    <div class="windowsMain">
                        <div class="windowsMainT">
                            <p class="windowsMainT1">{{item.atLxfs}}</p>
                            <p class="windowsMainT2" :title="item.atShdz">{{item.ssqName+','+item.atShdz}}</p>
                        </div>
                        <div class="windowsMainB">
                            <p class="windowsMainB2" @click="del(item.id)">删除</p>
                            <p class="windowsMainB3" v-show="item.optSfmr==1">默认地址</p>
                            <!-- <p class="windowsMainB4" v-show="item.optSfmr==0">
              <el-radio :label="index">设为默认地址</el-radio>
                            </p>-->
                        </div>
                    </div>
                </div>
            </el-radio-group>
        </div>
        <p class="add" @click="addAddress()">新建地址</p>
        <el-dialog :title="title" :visible.sync="dialogFormVisible" center @close="closeDialog">
            <el-form :model="form" :rules="rules" ref="form" class="forms">
                <el-form-item
                    label="收货人姓名："
                    :label-width="formLabelWidth"
                    class="input1"
                    prop="name"
                >
                    <el-input v-model="form.name" autocomplete="off" placeholder="长度不超过10字符"></el-input>
                </el-form-item>
                <el-form-item
                    label="联系电话："
                    :label-width="formLabelWidth"
                    class="input2"
                    prop="phone"
                >
                    <el-input v-model="form.phone" autocomplete="off" placeholder="电话号码或手机号码"></el-input>
                </el-form-item>
                <el-form-item
                    label="所在区域："
                    :label-width="formLabelWidth"
                    class="input3"
                    prop="selectedOptions"
                >
                <el-cascader
                    v-model="form.selectedOptions"
                    :props="{ value: 'regionCode', label: 'regionName' }"
                    :options="addressLists"
                    @change="handleChange"
                     ref="cascader"
                    placeholder="请选择省/市/区/街道"></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" :label-width="formLabelWidth" prop="address">
                    <el-input
                        v-model="form.address"
                        autocomplete="off"
                        placeholder="请输入详细地址，如道路、门牌号、楼栋号、单元等信息"
                    ></el-input>
                </el-form-item>
                <el-form-item label="设为默认地址" prop="delivery" class="delivery">
                    <el-switch v-model="form.delivery"></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancleF()">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
  <script>
import {
    provinceAndCityData,
    regionData,
    provinceAndCityDataPlus,
    regionDataPlus,
    CodeToText,
    TextToCode
} from "element-china-area-data";
import vfooter from "@/components/common/Footer";
import topHead from "@/components/common/topHead";
import footerCopy from "@/components/common/footerCopy";
export default {
    name: "Shopping",
    data() {
        var checkAge = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("年龄不能为空"));
            }
            setTimeout(() => {
                if (!Number.isInteger(value)) {
                    callback(new Error("请输入数字值"));
                } else {
                    if (value < 18) {
                        callback(new Error("必须年满18岁"));
                    } else {
                        callback();
                    }
                }
            }, 1000);
        };
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.ruleForm.checkPass !== "") {
                    this.$refs.ruleForm.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.pass) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            formLabelWidth: "120px",
            userId: "", //用户id
            checked: true,
            radio: 0,
            value1: null,
            desc: "",
            flag1: false,
            list: [1, 2, 3, 4, 5],
            AddressList: [], //地址数据
            title: "新建收货地址",
            addrId: "", //当前地址Id,
            dialogTableVisible: false,
            dialogFormVisible: false,
            addressLists:[],//存储省市区下拉列表数据
            cityCode:[],//选中的citycode
            cityTitle:[],//选中的cityname
            form: {
                name: "",
                phone: "", //号码
                address: "", //详细地址
                delivery: false, //是否默认地址
                options: regionData,
                selectedOptions: [],
                addressStr: "" //所在区域
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入收货人姓名",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 10,
                        message: "长度不超过10个字符",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: true,
                        message: "请输电话号码或手机号码",
                        trigger: "blur"
                    },
                    {
                        pattern: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,
                        message: "请输入合法手机号/电话号(区号-电话号)",
                        trigger: "blur"
                    }
                ],
                address: [
                    {
                        required: true,
                        message: "请输入详细地址",
                        trigger: "blur"
                    }
                ],
                selectedOptions: [
                    {
                        required: true,
                        message: "请选择省/市/区/街道",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    components: {
        topHead: topHead,
        vfooter: vfooter,
        footerCopy: footerCopy
    },
    created() {
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.userId = this.userInfo.id;
        }
        this.getAddress();
        this.getAddressList();//获取地址下拉选项数据
    },
    methods: {
        closeDialog() {
            this.$refs.form.resetFields();
        },
        cancleF() {
            this.dialogFormVisible = false;
            this.$refs.form.resetFields();
        },
        getAddressList(){
            var params = {};
            let url = "/city/getCityList";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    this.addressLists = res.data.data;
                    
                }
            });
        },
        handleChange(value){
            this.cityCode = value;
            this.cityTitle = this.$refs["cascader"].getCheckedNodes()[0].pathLabels;
        },
        addressChange(arr) {
            console.log(arr);
            console.log(
                CodeToText[arr[0]],
                CodeToText[arr[1]],
                CodeToText[arr[2]]
            );
            if (CodeToText[arr[1]] == "市辖区") {
                this.form.addressStr =
                    CodeToText[arr[0]] +
                    "," +
                    CodeToText[arr[0]] +
                    "," +
                    CodeToText[arr[2]];
            } else {
                this.form.addressStr =
                    CodeToText[arr[0]] +
                    "," +
                    CodeToText[arr[1]] +
                    "," +
                    CodeToText[arr[2]];
            }
        },
        getAddress() {
            //获取地址
            var params = {};
            params.createBy = this.userId;
            let url = "/dzgl/getList";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    // console.log(res, 456);
                    this.AddressList = res.data.data.list;
                }
            });
        },
        edit(item) {
            //编辑
            this.addrId = item.id;
            this.title = "修改收货地址";
            this.dialogFormVisible = true;
            this.form.name = item.atName; //联系人
            this.form.phone = item.atLxfs; //联系方式
            // 省市区回显
            if (item.ssq) {
                let aaa = item.ssq.split(",");
                this.form.selectedOptions = aaa;
            }
            this.form.address = item.atShdz; //窗口地址编辑回显，先清空
            this.form.delivery = item.optSfmr == 1?true:false;//是否默认 1：默认 0：否
        },
        addAddress() {
            //新建
            this.title = "新建收货地址";
            this.dialogFormVisible = true;
            this.form.name = ""; //联系人
            this.form.phone = ""; //联系方式
            this.form.addressStr = "";
            this.form.selectedOptions = [];
            // this.form.options = atShdz.split(',')[0];
            this.form.address = ""; //收货地址（英文逗号分隔）
            this.form.delivery = false; //是否默认 1：默认 0：否
        },
        del(id) {
            //删除地址
            this.$confirm("此操作将永久删除该地址, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                var params = {};
                params.ids = [id];
                let url = "/dzgl/delete";
                this.$http.post(url, params).then(res => {
                    if (res.data.code == 200) {
                        console.log(res, 456);
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.getAddress();
                    }
                });
            });
        },
        tab(index) {
            this.i = index;
        },
        onEnterSearch: function(e, searchVal) {
            console.log("search: " + this.searchVal);
        },
        submitForm(formName) {
            let url = "";
            if (this.title == "新建收货地址") {
                url = "/dzgl/insert"; //新增
            } else {
                url = "/dzgl/update"; //修改
            }
            this.$refs[formName].validate(valid => {
                if (valid) {
                    var params = {};
                    params.atName = this.form.name; //联系人
                    params.atLxfs = this.form.phone; //联系方式
                    params.atShdz = this.form.address; //窗口地址编辑回显，先清空; //收货地址（英文逗号分隔）
                    params.ssqBmList = this.form.selectedOptions;
                    params.ssq = this.cityCode.join()
                    if (this.form.delivery) {
                        params.optSfmr = 1; //是否默认 1：默认 0：否
                    } else {
                        params.optSfmr = 0; //是否默认 1：默认 0：否
                    }
                    if (this.title == "新建收货地址") {
                        params.createBy = this.userId; //用户id
                    } else {
                        //修改
                        params.id = this.addrId; //地址id
                    }

                    this.$http.post(url, params).then(res => {
                        if (res.data.code == 200) {
                            this.getAddress();
                            this.dialogFormVisible = false;
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    }
};
</script>
<style  scoped>
#myOrder {
    width: 99.8%;
    padding-bottom: 40px;
}
#myOrder::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
    overflow: hidden;
}
.windowsWrap {
    width: 100%;
}
.windowsWrap::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
    overflow: hidden;
}
.windows {
    float: left;
    width: 32.2%;
    height: 196px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
    margin-right: 10px;
    margin-bottom: 10px;
}
.windows:nth-child(3n + 3) {
    margin-right: 0px;
}
.windowsTop {
    width: 100%;
    height: 44px;
    line-height: 24px;
    background-color: #eeeeee;
    border: solid 1px #dddddd;
    box-sizing: border-box;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #333333;
}
.name {
    padding: 0;
}
.windowsTop i {
    font-size: 20px;
    float: right;
    cursor: pointer;
}
.windowsMain {
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    letter-spacing: 1px;
    color: #666666;
}
.windowsMainT {
    width: 100%;
    border-bottom: dashed 1px #aaaaaa;
    padding-bottom: 20px;
}
.windowsMainT1 {
    height: 40px;
    line-height: 40px;
}
.windowsMainT2 {
    height: 39px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 19px;
    letter-spacing: 1px;
    color: #666666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.windowsMainB {
    width: 100%;
    height: 25px;
    margin-top: 10px;
}
.windowsMainB1,
.windowsMainB2 {
    float: left;
    width: 44px;
    height: 22px;
    line-height: 22px;
    border-radius: 11px;
    border: solid 1px #999899;
    text-align: center;
    cursor: pointer;
    margin-right: 10px;
    color: #666666;
}
.windowsMainB3 {
    float: right;
    width: 72px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background-color: #f64420;
    border-radius: 11px;
    cursor: pointer;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    letter-spacing: 0px;
    color: #ffffff;
}
.windowsMainB4 {
    float: right;
    color: #666666;
    margin-top: 5px;
}
.add {
    width: 113px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background-color: #ffffff;
    border: solid 1px #dddddd;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #f2961f;
    cursor: pointer;
}
.forms::after {
    height: 0;
    clear: both;
    display: block;
    visibility: hidden;
    overflow: hidden;
}
.input1,
.input2 {
    width: 50%;
    float: left;
}
.input3 {
    clear: both;
}
.delivery {
    width: 200px;
    height: 35px;
    float: right;
}
</style>

                    
<style>
#myAddress .el-textarea {
    float: left;
    width: 80%;
}
#myAddress .el-textarea__inner {
    height: 90px;
}
#myAddress .el-dialog__header {
    border: 1px solid #cccccc;
}
#myAddress .el-dialog__title {
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 2px;
    color: #f64420;
    text-align: center;
}

#myAddress .el-dialog__headerbtn .el-dialog__close {
    color: #909399;
    font-size: 28px;
}
#myAddress .el-dialog--center .el-dialog__footer {
    clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/Orderlist/myAddress.vue